import { render, staticRenderFns } from "./AsesoresSection.vue?vue&type=template&id=28dc19ce&scoped=true&"
import script from "./AsesoresSection.vue?vue&type=script&lang=js&"
export * from "./AsesoresSection.vue?vue&type=script&lang=js&"
import style0 from "./AsesoresSection.vue?vue&type=style&index=0&id=28dc19ce&prod&lang=scss&scoped=true&"
import style1 from "./AsesoresSection.vue?vue&type=style&index=1&id=28dc19ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc19ce",
  null
  
)

export default component.exports